import React, { FC } from "react";
import { ButtonStyled } from "./elements";
import { ButtonParams } from "./types";

const Button: FC<ButtonParams> = (props) => {
  const { children, size, id, loading, danger } = props;

  return (
    <ButtonStyled
      {...props}
      size={size || "middle"}
      id={id || ""}
      loading={loading || false}
      danger={danger || false}
    >
      {children}
    </ButtonStyled>
  );
};

export default Button;
